// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"PageMenuButton-menuButton-1zEuq MenuButton-menuButton-3nh0N","label":"PageMenuButton-label-Oi8V9"};